






















































































import Vue from 'vue';
import customerVuex from '../../vuex/common';
import customerClient from '../../apis';
import Customer from '../../models/Customer';

const suggestCustomers: Customer[] = [];
const suggestTimeout: any = null;

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      suggestTimeout,
      searchKeyword: '',
      showSuggest: false,
      suggestCursor: -1,
      suggestCustomers,
      historySearchKeywords: [],
      onSearchMode: false,
      avatarUrl: require('assets/img/common/avatar.png'),
    };
  },
  computed: {
    searchFieldsDisplay(): string {
      const strings: any = {
        'wxProps.nickname': '昵称',
        'realname': '姓名',
        'telephone': '手机',
        'openid': 'openid',
      };
      return this.customerState.searchFields.filter((field) => {
        return strings[field] !== undefined;
      }).map((field) => {
        return strings[field] || '';
      }).join('、');
    },
    placeholder(): string {
      return this.searchFieldsDisplay ? `输入${this.searchFieldsDisplay}来搜索客户` : '';
    },
    historyKeywords(): Array<string> {
      const kwds = JSON.parse(JSON.stringify(this.historySearchKeywords));
      return kwds.reverse();
    },
    historyKey(): string {
      return `customerSearch${this.accountState.account.weixinId}`.replace('_', '');
    },
  },
  methods: {
    avatar(customer: any): string {
      return customer && customer.wxProps.headimgurl ? customer.wxProps.headimgurl.replace('http://', 'https://') : this.avatarUrl;
    },
    suggest(): void {
      clearTimeout(this.suggestTimeout);
      this.suggestTimeout = setTimeout(() => {
        customerClient.suggest({
          page: 1,
          key: this.searchKeyword,
        }).success((r) => {
          this.suggestCustomers = r.customers.map((c: Customer) => {
            return new Customer(c);
          }).splice(0, 10);
          this.suggestCursor = -1;
        });
      }, 300);
    },
    onSearch(): void {
      if (this.suggestCursor !== -1) {
        const customer = this.suggestCustomers[this.suggestCursor];
        this.showCustomerDetail(this.suggestCustomers[this.suggestCursor]);
      } else {
        this.$store.commit('UPDATE_CUSTOMER_QUERY', {
          key: 'keyword',
          value: {
            fields: this.customerState.searchFields,
            key: this.searchKeyword,
          },
        });
        this.$store.commit('DELETE_CUSTOMER_QUERY_SUBSCRIBE');
        this.$store.commit('CUSTOMER_TABLE_REFRESH');
        this.onSearchMode = true;
        this.showSuggest = false;
        this.$emit('onSearch');
      }
    },
    onHistorySearch(kwd: string): void {
      this.searchKeyword = kwd;
      this.onSearch();
    },
    cancelSearch(): void {
      this.$store.commit('INIT_CUSTOMER_QUERY');
      this.$store.commit('CUSTOMER_TABLE_REFRESH');
      this.onSearchMode = false;
      this.searchKeyword = null;
      this.showSuggest = false;
      this.suggestCustomers = [];
      this.$emit('cancelSearch');
    },
    hitTelephone(customer: Customer): boolean {
      if (!customer.phone) {
        return false;
      } else {
        return customer.phone.indexOf(this.searchKeyword) !== -1;
      }
    },
    hitRealname(customer: Customer): boolean {
      if (!customer.realName) {
        return false;
      } else {
        return customer.realName.indexOf(this.searchKeyword) !== -1;
      }
    },
    showCustomerDetail(customer: Customer): void {
      this.$store.commit('SHOW_CUSTOMER_DETAIL', customer);
      this.showSuggest = false;
      this.searchKeyword = customer.wxProps.nickname;
      this.setHistorySearchKeyword();
      this.onSearchMode = true;
    },
    nextSuggest(): void {
      if (this.suggestCursor < this.suggestCustomers.length - 1) {
        this.suggestCursor++;
      }
    },
    prevSuggest(): void {
      if (this.suggestCursor > 0) {
        this.suggestCursor--;
      } else {
        this.suggestCursor = -1;
      }
    },
    setHistorySearchKeyword(): void {
      const kwd = this.searchKeyword;
      const index = this.historySearchKeywords.indexOf(kwd);
      if (index !== -1) {
        this.historySearchKeywords.splice(index, 1);
      }
      this.historySearchKeywords.push(kwd);
      if (this.historySearchKeywords.length > 10) {
        this.historySearchKeywords.splice(0, this.historySearchKeywords.length - 10);
      }
      Vue.localStorage.set(this.historyKey, JSON.stringify(this.historySearchKeywords));
    },
    deleteHistoryKwd(kwd: string): void {
      const index = this.historySearchKeywords.indexOf(kwd);
      if (index !== -1) {
        this.historySearchKeywords.splice(index, 1);
      }
      Vue.localStorage.set(this.historyKey, JSON.stringify(this.historySearchKeywords));
    },
  },
  mounted() {
    this.historySearchKeywords = JSON.parse(Vue.localStorage.get(this.historyKey, '[]'));
  },
});
